import React from "react";
import ScanHand from "../../ScanHand";

const Screen10 = () => {
    return <ScanHand />;
};

export default Screen10;
